import gql from 'graphql-tag'


export const SEE_CATEGORIES = gql`
    query seeCategories($userChannelId:String!){
        seeCategories(userChannelId:$userChannelId){
            id
            categoryName
            order
            categoryCount
        }
    }
`